import React from 'react';
import { Button } from "@blueprintjs/core";

class Search extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tuKhoa: this.props.parents.state.tuKhoa
    }
  }

  handleSearch(e) {
    e.preventDefault();
    this.props.parents.handleSearch();
  }

  handleChange(e) {
    this.setState({
      tuKhoa: e.target.value
    })
    let data = {
      target: {
        name: 'tuKhoa',
        value: e.target.value
      }
    }
    this.props.parents.handleChange(data)
  }

  render() {
    return (
      <section className="wrap-block search-container">
        <form className="search-form" onSubmit={this.handleSearch.bind(this)}>
          <input
            type="text"
            name="tuKhoa"
            placeholder="Nhập từ khóa để tìm kiếm..."
            className="search-input"
            value={this.state.tuKhoa}
            onChange={this.handleChange.bind(this)}
            />
          <Button
            type="submit"
            text="Tìm kiếm"
            className={this.props.parents.state.tableLoading ? (this.props.parents.state.searchLoading ? "btn-green tt-search btn-loading" : "btn-green tt-search btn-disable") : "btn-green tt-search"}
            />
        </form>
      </section>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/modules/category/Search.jsx